var _style, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoJcDecauxDynamicContent01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 433.3 173.5",
    style: {
      enableBackground: "new 0 0 433.3 173.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.bananas{fill:#FFFFFF;}\r\n\t.maracujas{fill:#173559;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bananas",
    d: "M0,14.8c0,0,112.5-5.4,175.2-10.8S389-14.8,432.6,173.5H0V14.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M70.8,72.7c0,2.7-0.7,7.1-7,7.1c-3.5,0-6.9-1.9-6.9-6.5v-1.8h4.2v0.9c0,2,0.5,3.5,2.7,3.5c2.4,0,2.4-2,2.4-3.4 V58.4h4.6V72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M87.4,65.4c-0.3-2.1-2.3-3.7-4.6-3.7c-4.1,0-5.7,3.5-5.7,7.2c0,3.5,1.5,7,5.7,7c2.8,0,4.4-1.9,4.7-4.7h4.4 c-0.5,5.2-4.1,8.5-9.2,8.5c-6.5,0-10.3-4.8-10.3-10.9c0-6.2,3.8-11,10.3-11c4.6,0,8.5,2.7,9,7.5H87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M98.3,62.2h3.3c4.6,0,6,2.7,6,6.9c0,4.6-2.5,6.3-5.2,6.3h-4.1V62.2z M93.7,79.2h9c6.4,0,9.5-4.5,9.5-10.6 c0-6.9-4.1-10.3-9.5-10.3h-9V79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M117.5,70.1c0.1-1.2,0.8-3.2,3.5-3.2c2,0,2.9,1.1,3.3,3.2H117.5z M128.4,72.7c0.3-4.7-2.2-9-7.3-9 c-4.6,0-7.7,3.5-7.7,8c0,4.7,3,8,7.7,8c3.4,0,5.9-1.5,7.1-5.1h-3.7c-0.3,0.9-1.6,2-3.3,2c-2.3,0-3.6-1.2-3.7-3.8H128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M140.2,69.5c-0.3-1.7-1.3-2.6-3.1-2.6c-2.7,0-3.5,2.7-3.5,4.9c0,2.2,0.8,4.8,3.5,4.8c1.9,0,3-1.2,3.3-3.1h4 c-0.5,4-3.3,6.2-7.3,6.2c-4.6,0-7.6-3.2-7.6-7.8c0-4.7,2.8-8.2,7.7-8.2c3.6,0,6.8,1.9,7.1,5.7H140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M155.3,73.4c0,0.9-0.1,3.5-3.4,3.5c-1.3,0-2.5-0.4-2.5-1.9c0-1.5,1.2-2,2.5-2.2c1.3-0.2,2.8-0.3,3.5-0.9V73.4z  M149.9,68.8c0.1-1.6,1.2-2.3,2.7-2.3c1.5,0,2.7,0.3,2.7,2c0,1.7-2.4,1.6-4.9,2c-2.6,0.4-5.2,1.2-5.2,4.6c0,3.1,2.3,4.5,5.2,4.5 c1.8,0,3.8-0.5,5.1-1.9c0,0.5,0.1,1,0.3,1.5h4.2c-0.4-0.6-0.5-2-0.5-3.4V68c0-3.6-3.6-4.3-6.6-4.3c-3.4,0-6.9,1.2-7.1,5.1H149.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M175.9,79.2h-4v-2.1h-0.1c-1.1,1.7-2.9,2.5-4.6,2.5c-4.4,0-5.5-2.5-5.5-6.2v-9.3h4.2v8.5 c0,2.5,0.7,3.7,2.7,3.7c2.3,0,3.2-1.3,3.2-4.3v-7.9h4.2V79.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "maracujas",
    points: "182,71.3 177,64.1 181.7,64.1 184.4,68.1 187,64.1 191.6,64.1 186.7,71.2 192.2,79.2 187.5,79.2  184.3,74.5 181.2,79.2 176.5,79.2  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M57,89.4h9.6c8.3,0.2,12.7,4.8,12.7,13.8c0,9.1-4.4,13.6-12.7,13.8H57V89.4z M59.6,114.8h5.6 c7.9,0,11.4-3.3,11.4-11.6c0-8.2-3.4-11.6-11.4-11.6h-5.6V114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M80.8,97h2.6l6.6,17l6.2-17h2.4l-8.7,23c-1.4,3.4-2.2,4.3-5.3,4.3c-1,0-1.5,0-1.9-0.2v-2.1 c0.6,0.1,1.1,0.2,1.7,0.2c2.2,0,2.7-1.3,3.5-3.1l0.9-2.3L80.8,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M100.9,97h2.4v3.4h0.1c0.9-2.4,3.6-4,6.4-4c5.6,0,7.3,2.9,7.3,7.7V117h-2.4v-12.5c0-3.4-1.1-6-5.1-6 c-3.9,0-6.2,2.9-6.3,6.9V117h-2.4V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M121.5,103.1c0.2-4.7,3.5-6.7,8.1-6.7c3.5,0,7.4,1.1,7.4,6.4v10.6c0,0.9,0.5,1.5,1.4,1.5 c0.3,0,0.6-0.1,0.8-0.2v2.1c-0.5,0.1-0.9,0.2-1.6,0.2c-2.5,0-2.9-1.4-2.9-3.5h-0.1c-1.7,2.6-3.4,4.1-7.3,4.1 c-3.7,0-6.7-1.8-6.7-5.8c0-5.6,5.5-5.8,10.7-6.4c2-0.2,3.1-0.5,3.1-2.7c0-3.3-2.4-4.1-5.2-4.1c-3,0-5.3,1.4-5.3,4.6H121.5z  M134.5,106.1L134.5,106.1c-0.4,0.6-1.5,0.8-2.1,0.9c-4.1,0.7-9.3,0.7-9.3,4.6c0,2.4,2.2,3.9,4.5,3.9c3.7,0,7-2.4,7-6.3V106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M141.9,97h2.2v3.4h0.1c1.3-2.4,3.4-3.9,6.5-3.9c2.6,0,5,1.3,5.7,3.9c1.2-2.6,3.7-3.9,6.4-3.9 c4.4,0,6.6,2.3,6.6,7V117H167v-13.4c0-3.3-1.2-5.1-4.7-5.1c-4.2,0-5.4,3.5-5.4,7.2V117h-2.4v-13.6c0-2.7-1.1-5-4.2-5 c-4.2,0-5.9,3.2-6,7.4V117h-2.4V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M174.2,89.4h2.4v3.9h-2.4V89.4z M174.2,97h2.4v20h-2.4V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M195.4,103.3c-0.7-3-2.5-4.8-5.7-4.8c-4.7,0-7,4.3-7,8.5s2.3,8.5,7,8.5c3,0,5.5-2.4,5.8-5.7h2.4 c-0.7,4.8-3.8,7.7-8.2,7.7c-6.1,0-9.4-4.8-9.4-10.6c0-5.7,3.3-10.6,9.4-10.6c4.3,0,7.6,2.3,8.1,6.9H195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M232.8,97.7c-0.9-4.3-4.5-6.7-8.5-6.7c-7.3,0-10.4,6.1-10.4,12.2c0,6,3.1,12.2,10.4,12.2 c5.1,0,8.4-3.9,8.9-8.9h2.6c-0.7,6.8-5,11.1-11.5,11.1c-8.7,0-13-6.9-13-14.4c0-7.6,4.3-14.4,13-14.4c5.2,0,10.4,3.1,11.1,8.9 H232.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M257.3,107c0,5.7-3.3,10.6-9.4,10.6c-6.1,0-9.4-4.8-9.4-10.6c0-5.7,3.3-10.6,9.4-10.6 C254,96.4,257.3,101.3,257.3,107z M240.8,107c0,4.3,2.3,8.5,7,8.5c4.7,0,7-4.3,7-8.5s-2.3-8.5-7-8.5 C243.2,98.5,240.8,102.8,240.8,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M260.9,97h2.4v3.4h0.1c0.9-2.4,3.6-4,6.4-4c5.6,0,7.3,2.9,7.3,7.7V117h-2.4v-12.5c0-3.4-1.1-6-5.1-6 c-3.9,0-6.2,2.9-6.3,6.9V117h-2.4V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M285.6,97h4.1v2.1h-4.1v13.5c0,1.6,0.2,2.5,2,2.6c0.7,0,1.4,0,2.1-0.1v2.1c-0.7,0-1.4,0.1-2.2,0.1 c-3.3,0-4.4-1.1-4.3-4.5V99.1h-3.5V97h3.5v-6h2.4V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M294.6,107.7c0,3.6,1.9,7.9,6.6,7.9c3.6,0,5.5-2.1,6.3-5.1h2.4c-1,4.5-3.7,7.2-8.7,7.2c-6.4,0-9-4.9-9-10.6 c0-5.3,2.7-10.6,9-10.6c6.4,0,9,5.6,8.8,11.2H294.6z M307.6,105.6c-0.1-3.7-2.4-7.1-6.4-7.1c-4,0-6.2,3.5-6.6,7.1H307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M313.2,97h2.4v3.4h0.1c0.9-2.4,3.6-4,6.4-4c5.6,0,7.3,2.9,7.3,7.7V117H327v-12.5c0-3.4-1.1-6-5.1-6 c-3.9,0-6.2,2.9-6.3,6.9V117h-2.4V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maracujas",
    d: "M338,97h4.1v2.1H338v13.5c0,1.6,0.2,2.5,2,2.6c0.7,0,1.4,0,2.1-0.1v2.1c-0.7,0-1.4,0.1-2.2,0.1 c-3.3,0-4.4-1.1-4.3-4.5V99.1H332V97h3.5v-6h2.4V97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJcDecauxDynamicContent01);
export default __webpack_public_path__ + "static/media/logo-jc-decaux-dynamic-content-01.cb807da9d9bcee5b8ffb898a58e92f84.svg";
export { ForwardRef as ReactComponent };